/** @format */

import Home from "./Home";

export default Home;